import type { CSSProperties } from "react";

export function featurePageCardStyle(
  hasImage: boolean,
  accent: string | null | undefined,
): CSSProperties | undefined {
  if (hasImage) return undefined;
  const fallbackAccent = accent ?? "#7c3aed";
  return {
    backgroundImage: `radial-gradient(circle at 20% 15%, ${fallbackAccent}cc, transparent 48%), linear-gradient(145deg, ${fallbackAccent}55, #09090b 72%)`,
  };
}
